import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useStore } from '@/contexts/StoreContext';
import { useTemplate } from '@/templates/TemplateContext';
import type { PageHeroProps } from '@/templates/tipos';

/** O cabeçalho das páginas internas: o do template, se ele tiver um. */
export function PageHero(props: PageHeroProps) {
  const template = useTemplate();
  if (template?.PageHero) {
    const HeroDoTemplate = template.PageHero;
    return <HeroDoTemplate {...props} />;
  }
  return <PageHeroClassico {...props} />;
}

function PageHeroClassico({
  title,
  breadcrumbs = [],
  className = '',
}: PageHeroProps) {
  const { store } = useStore();
  const { t } = useTranslation();
  const backgroundImage = store?.heroBackgroundUrl;

  return (
    <section
      className={`relative h-[60vh] min-h-[400px] -mt-24 pt-24 flex items-center justify-center overflow-hidden ${className}`}
    >
      {/* Background */}
      {backgroundImage && (
        <div
          className="absolute inset-0 -top-24 bg-cover bg-center"
          style={{ backgroundImage: `url(${backgroundImage})` }}
        />
      )}

      {/* Overlay */}
      <div className="absolute inset-0 -top-24 bg-gradient-to-b from-background/20 via-background/50 to-background" />

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex flex-col items-center text-center">
          <h1 className="font-display text-4xl md:text-5xl font-bold text-foreground mb-4">
            {title}
          </h1>

          {/* Breadcrumbs */}
          {breadcrumbs.length > 0 && (
            <nav className="flex items-center gap-2 text-sm">
              <Link
                to="/"
                className="flex items-center gap-1 text-muted-foreground hover:text-primary transition-colors"
              >
                <Home className="w-4 h-4" />
                <span>{t('store.header.nav.home')}</span>
              </Link>

              {breadcrumbs.map((crumb, index) => (
                <span key={index} className="flex items-center gap-2">
                  <ChevronRight className="w-4 h-4 text-muted-foreground" />
                  {crumb.href ? (
                    <Link
                      to={crumb.href}
                      className="text-muted-foreground hover:text-primary transition-colors"
                    >
                      {crumb.label}
                    </Link>
                  ) : (
                    <span className="text-foreground font-medium">{crumb.label}</span>
                  )}
                </span>
              ))}
            </nav>
          )}
        </div>
      </div>
    </section>
  );
}

export default PageHero;
